import React, { useEffect } from "react";

const SUCCESS_DISMISS_MS = 2000;

export function CrewPilotInlineSuccess({
  message,
  onDismiss,
  autoDismissMs = SUCCESS_DISMISS_MS,
}) {
  useEffect(() => {
    if (!onDismiss) return undefined;

    const timer = setTimeout(onDismiss, autoDismissMs);
    return () => clearTimeout(timer);
  }, [autoDismissMs, onDismiss]);

  return (
    <div className="cp-inline-success" role="status" aria-live="polite">
      <svg
        className="cp-inline-success-icon"
        viewBox="0 0 52 52"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <circle className="checkmark-circle" cx="26" cy="26" r="24" />
        <path className="checkmark-check" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
      </svg>
      <span className="cp-inline-success-message">{message}</span>
    </div>
  );
}
